export enum AppNotificationType {
    Error,
    Success,
    Team
}

export type AppNotification = {
    type: AppNotificationType;
    message: string;
}